(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.querySelector('[data-cart-drawer]');
    if (!dialog || dialog.dataset.cartDrawerReady) return;
    dialog.dataset.cartDrawerReady = 'true';

    const FREE_SHIPPING_THRESHOLD_CENTS = 99900;

    const strings = JSON.parse(dialog.querySelector('[data-cart-drawer-strings]').textContent);
    const countEl = dialog.querySelector('[data-cart-drawer-count]');
    const errorEl = dialog.querySelector('[data-cart-drawer-error]');
    const shippingEl = dialog.querySelector('[data-cart-drawer-shipping]');
    const shippingRemainingEl = dialog.querySelector('[data-cart-drawer-shipping-remaining]');
    const shippingUnlockedEl = dialog.querySelector('[data-cart-drawer-shipping-unlocked]');
    const shippingFillEl = dialog.querySelector('[data-cart-drawer-shipping-fill]');
    const itemsEl = dialog.querySelector('[data-cart-drawer-items]');
    const emptyEl = dialog.querySelector('[data-cart-drawer-empty]');
    const recsEl = dialog.querySelector('[data-cart-drawer-recommendations]');
    const recsListEl = dialog.querySelector('[data-cart-drawer-recommendations-list]');
    const footerEl = dialog.querySelector('[data-cart-drawer-footer]');
    const subtotalEl = dialog.querySelector('[data-cart-drawer-subtotal]');

    let busy = false;
    let closing = false;
    let recsLoadedFor = null;
    let errorTimer = null;

    const formatMoney = (cents) =>
      new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(cents / 100);

    const escapeHtml = (value) =>
      String(value == null ? '' : value).replace(/[&<>"']/g, (char) => (
        { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]
      ));

    const imageUrl = (url, width) =>
      url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;

    const showError = (message) => {
      errorEl.textContent = message || strings.error_generic;
      errorEl.hidden = false;
      clearTimeout(errorTimer);
      errorTimer = setTimeout(() => {
        errorEl.hidden = true;
      }, 6000);
    };

    const hideError = () => {
      clearTimeout(errorTimer);
      errorEl.hidden = true;
    };

    const setBusy = (value) => {
      busy = value;
      dialog.classList.toggle('cart-drawer--busy', value);
      itemsEl.querySelectorAll('button').forEach((button) => {
        button.disabled = value;
      });
    };

    const updateBadge = (count) => {
      const cartLink = document.querySelector('.header__cart');
      if (!cartLink) return;
      let badge = cartLink.querySelector('.header__cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'header__cart-count';
          cartLink.appendChild(badge);
        }
        badge.textContent = count;
        badge.hidden = false;
      } else if (badge) {
        badge.hidden = true;
      }
    };

    const renderShipping = (cart) => {
      if (cart.item_count === 0) {
        shippingEl.hidden = true;
        return;
      }
      shippingEl.hidden = false;
      const subtotal = cart.items_subtotal_price;
      const percent = Math.min((subtotal / FREE_SHIPPING_THRESHOLD_CENTS) * 100, 100);
      shippingFillEl.style.width = percent + '%';
      if (subtotal >= FREE_SHIPPING_THRESHOLD_CENTS) {
        shippingRemainingEl.hidden = true;
        shippingUnlockedEl.hidden = false;
      } else {
        shippingRemainingEl.textContent = strings.free_shipping_remaining.replace(
          '[amount]',
          formatMoney(FREE_SHIPPING_THRESHOLD_CENTS - subtotal)
        );
        shippingRemainingEl.hidden = false;
        shippingUnlockedEl.hidden = true;
      }
    };

    const itemMarkup = (item) => {
      const image = item.image
        ? '<img class="cart-drawer__item-image" src="' + escapeHtml(imageUrl(item.image, 160)) + '" alt="" width="80" height="80" loading="lazy">'
        : '<div class="cart-drawer__item-image cart-drawer__item-image--placeholder"></div>';
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>'
        : '';
      const key = escapeHtml(item.key);
      return (
        '<div class="cart-drawer__item">' +
        image +
        '<div class="cart-drawer__item-info">' +
        '<p class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</p>' +
        variant +
        '<div class="cart-drawer__item-row">' +
        '<div class="cart-drawer__stepper">' +
        '<button type="button" class="cart-drawer__stepper-button" data-cart-key="' + key + '" data-cart-quantity="' + (item.quantity - 1) + '" aria-label="' + escapeHtml(strings.decrease_quantity) + '">&minus;</button>' +
        '<span class="cart-drawer__stepper-value">' + item.quantity + '</span>' +
        '<button type="button" class="cart-drawer__stepper-button" data-cart-key="' + key + '" data-cart-quantity="' + (item.quantity + 1) + '" aria-label="' + escapeHtml(strings.increase_quantity) + '">+</button>' +
        '</div>' +
        '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
        '</div>' +
        '<button type="button" class="cart-drawer__item-remove" data-cart-key="' + key + '" data-cart-quantity="0">' + escapeHtml(strings.remove) + '</button>' +
        '</div>' +
        '</div>'
      );
    };

    const recMarkup = (product) => {
      const featured = typeof product.featured_image === 'string'
        ? product.featured_image
        : (product.featured_image && product.featured_image.url) || (product.images && product.images[0]);
      const image = featured
        ? '<img class="cart-drawer__rec-image" src="' + escapeHtml(imageUrl(featured, 120)) + '" alt="" width="56" height="56" loading="lazy">'
        : '<div class="cart-drawer__rec-image cart-drawer__rec-image--placeholder"></div>';
      const availableVariant = (product.variants || []).find((variant) => variant.available);
      const addButton = availableVariant
        ? '<button type="button" class="cart-drawer__rec-add" data-cart-add="' + availableVariant.id + '">' + escapeHtml(strings.add) + '</button>'
        : '<button type="button" class="cart-drawer__rec-add" disabled>' + escapeHtml(strings.sold_out) + '</button>';
      return (
        '<div class="cart-drawer__rec">' +
        image +
        '<div class="cart-drawer__rec-info">' +
        '<a class="cart-drawer__rec-title" href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a>' +
        '<span class="cart-drawer__rec-price">' + formatMoney(product.price) + '</span>' +
        addButton +
        '</div>' +
        '</div>'
      );
    };

    const loadRecommendations = (productId) => {
      if (recsLoadedFor === productId) return;
      recsLoadedFor = productId;
      fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=related', {
        headers: { Accept: 'application/json' }
      })
        .then((response) => (response.ok ? response.json() : { products: [] }))
        .then((data) => {
          const products = (data && data.products) || [];
          if (products.length === 0) {
            recsEl.hidden = true;
            return;
          }
          recsListEl.innerHTML = products.map(recMarkup).join('');
          recsEl.hidden = false;
        })
        .catch(() => {
          recsEl.hidden = true;
        });
    };

    const renderCart = (cart) => {
      const hasItems = cart.item_count > 0;
      countEl.textContent = '(' + cart.item_count + ')';
      updateBadge(cart.item_count);
      renderShipping(cart);
      itemsEl.innerHTML = hasItems ? cart.items.map(itemMarkup).join('') : '';
      itemsEl.hidden = !hasItems;
      emptyEl.hidden = hasItems;
      footerEl.hidden = !hasItems;
      subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
      if (hasItems) {
        loadRecommendations(cart.items[0].product_id);
      } else {
        recsEl.hidden = true;
        recsLoadedFor = null;
      }
    };

    const refresh = () =>
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((response) => response.json())
        .then(renderCart)
        .catch(() => {});

    const open = () => {
      if (dialog.open) return;
      closing = false;
      dialog.classList.remove('is-closing');
      dialog.showModal();
    };

    const close = () => {
      if (!dialog.open || closing) return;
      closing = true;
      dialog.classList.add('is-closing');
      dialog.addEventListener(
        'animationend',
        () => {
          dialog.classList.remove('is-closing');
          dialog.close();
          closing = false;
        },
        { once: true }
      );
    };

    const changeQuantity = (key, quantity) => {
      if (busy) return;
      hideError();
      setBusy(true);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(async (response) => {
          const data = await response.json().catch(() => ({}));
          if (!response.ok) {
            showError(data.description || data.message);
            return refresh();
          }
          renderCart(data);
        })
        .catch(() => {
          showError();
        })
        .finally(() => {
          setBusy(false);
        });
    };

    const addVariant = (variantId, button) => {
      if (busy) return;
      hideError();
      button.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      })
        .then(async (response) => {
          const data = await response.json().catch(() => ({}));
          if (!response.ok) {
            showError(data.description || data.message);
            return;
          }
          return refresh();
        })
        .catch(() => {
          showError();
        })
        .finally(() => {
          button.disabled = false;
        });
    };

    dialog.querySelector('[data-cart-drawer-close]').addEventListener('click', close);

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        close();
        return;
      }
      const quantityButton = event.target.closest('[data-cart-key]');
      if (quantityButton) {
        changeQuantity(quantityButton.dataset.cartKey, parseInt(quantityButton.dataset.cartQuantity, 10));
        return;
      }
      const addButton = event.target.closest('[data-cart-add]');
      if (addButton) {
        addVariant(addButton.dataset.cartAdd, addButton);
      }
    });

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-open-cart]');
      if (!trigger) return;
      event.preventDefault();
      hideError();
      open();
      refresh();
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      event.preventDefault();
      const submitButton = form.querySelector('[type="submit"]');
      if (submitButton) submitButton.disabled = true;
      hideError();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(async (response) => {
          const data = await response.json().catch(() => ({}));
          open();
          if (!response.ok) {
            showError(data.description || data.message);
          }
          return refresh();
        })
        .catch(() => {
          open();
          showError();
        })
        .finally(() => {
          if (submitButton) submitButton.disabled = false;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["login-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    const modal = document.querySelector('[data-login-modal]');
    if (!modal) return;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-open-login]');
      if (trigger) {
        event.preventDefault();
        modal.showModal();
      }
    });

    modal.addEventListener('click', (event) => {
      if (event.target === modal) modal.close();
    });

    const closeButton = modal.querySelector('[data-login-close]');
    if (closeButton) closeButton.addEventListener('click', () => modal.close());
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.product-card__swatch');
    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();

    const card = swatch.closest('.product-card');
    if (!card) return;

    card.querySelectorAll('.product-card__swatch').forEach((other) => {
      other.classList.remove('is-active');
      other.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('is-active');
    swatch.setAttribute('aria-pressed', 'true');

    const imageUrl = swatch.dataset.swatchImage;
    if (!imageUrl) return;

    const image = card.querySelector('.product-card__image');
    if (!image || image.tagName !== 'IMG') return;

    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = imageUrl;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-overlay"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.querySelector('[data-search-overlay]');
    if (!dialog) return;

    const input = dialog.querySelector('[data-search-input]');
    const defaultBlock = dialog.querySelector('[data-search-default]');
    const resultsBlock = dialog.querySelector('[data-search-results]');
    const resultsGrid = dialog.querySelector('[data-search-results-grid]');
    const emptyBlock = dialog.querySelector('[data-search-empty]');
    const predictiveBase = dialog.dataset.predictiveUrl || '/search/suggest';

    let debounceTimer = null;
    let controller = null;
    let closeTimer = null;

    const abortPending = () => {
      clearTimeout(debounceTimer);
      if (controller) {
        controller.abort();
        controller = null;
      }
    };

    const showDefault = () => {
      defaultBlock.hidden = false;
      resultsBlock.hidden = true;
      emptyBlock.hidden = true;
    };

    const resetOverlay = () => {
      abortPending();
      input.value = '';
      showDefault();
    };

    const syncViewportHeight = () => {
      if (!window.visualViewport) return;
      dialog.style.setProperty('--search-viewport-height', window.visualViewport.height + 'px');
    };

    const syncHeaderOffset = () => {
      const header = document.querySelector('.header');
      const headerSection = header ? header.closest('[id^="shopify-section-"]') : null;
      const target = headerSection || header;
      if (!target) return;
      const bottom = Math.max(target.getBoundingClientRect().bottom, 0);
      dialog.style.setProperty('--search-header-offset', bottom + 'px');
    };

    const desktopQuery = window.matchMedia('(min-width: 750px)');
    const backdrop = document.querySelector('[data-search-backdrop]');

    const onEscape = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeOverlay();
      }
    };

    const openOverlay = () => {
      if (dialog.open) return;
      syncHeaderOffset();

      if (desktopQuery.matches) {
        dialog.show();
        if (backdrop) backdrop.hidden = false;
        document.addEventListener('keydown', onEscape);
      } else {
        dialog.showModal();
      }

      document.documentElement.style.overflow = 'hidden';
      syncViewportHeight();
      window.addEventListener('resize', syncHeaderOffset);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', syncViewportHeight);
      }
      requestAnimationFrame(() => input.focus());
    };

    const closeOverlay = () => {
      if (!dialog.open || dialog.classList.contains('search-overlay--closing')) return;
      dialog.classList.add('search-overlay--closing');
      if (backdrop && !backdrop.hidden) {
        backdrop.classList.add('search-overlay-backdrop--closing');
      }

      const finishClose = () => {
        clearTimeout(closeTimer);
        dialog.removeEventListener('animationend', onAnimationEnd);
        if (dialog.open) dialog.close();
      };

      const onAnimationEnd = (event) => {
        if (event.target !== dialog) return;
        finishClose();
      };

      dialog.addEventListener('animationend', onAnimationEnd);
      closeTimer = setTimeout(finishClose, 400);
    };

    const renderProducts = (products) => {
      resultsGrid.textContent = '';

      products.forEach((product) => {
        const item = document.createElement('a');
        item.className = 'search-overlay__item';
        item.href = product.url;

        const media = document.createElement('span');
        media.className = 'search-overlay__media';

        if (product.image) {
          const img = document.createElement('img');
          img.className = 'search-overlay__image';
          const separator = product.image.includes('?') ? '&' : '?';
          img.src = product.image + separator + 'width=600';
          img.alt = product.title;
          img.loading = 'lazy';
          img.width = 600;
          img.height = 750;
          media.appendChild(img);
        }

        const title = document.createElement('span');
        title.className = 'search-overlay__item-title';
        title.textContent = product.title;

        const price = document.createElement('span');
        price.className = 'search-overlay__item-price';
        price.textContent = '$' + product.price;

        item.appendChild(media);
        item.appendChild(title);
        item.appendChild(price);
        resultsGrid.appendChild(item);
      });
    };

    const performSearch = (term) => {
      if (controller) controller.abort();
      controller = new AbortController();

      const params = new URLSearchParams({
        q: term,
        'resources[type]': 'product',
        'resources[limit]': '8',
        'resources[options][unavailable_products]': 'last',
      });

      fetch(predictiveBase + '.json?' + params.toString(), { signal: controller.signal })
        .then((response) => {
          if (!response.ok) throw new Error('Predictive search failed');
          return response.json();
        })
        .then((data) => {
          const results = data && data.resources && data.resources.results;
          const products = (results && results.products) || [];
          defaultBlock.hidden = true;

          if (products.length > 0) {
            renderProducts(products);
            resultsBlock.hidden = false;
            emptyBlock.hidden = true;
          } else {
            resultsBlock.hidden = true;
            emptyBlock.hidden = false;
          }
        })
        .catch((error) => {
          if (error && error.name === 'AbortError') return;
          showDefault();
        });
    };

    input.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      const term = input.value.trim();

      if (term.length < 2) {
        abortPending();
        showDefault();
        return;
      }

      debounceTimer = setTimeout(() => performSearch(term), 300);
    });

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-open-search]');
      if (!opener) return;
      event.preventDefault();
      openOverlay();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target.closest('[data-search-close]')) {
        closeOverlay();
        return;
      }
      if (event.target === dialog) closeOverlay();
    });

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeOverlay();
    });

    if (backdrop) {
      backdrop.addEventListener('click', () => closeOverlay());
    }

    dialog.addEventListener('close', () => {
      dialog.classList.remove('search-overlay--closing');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onEscape);
      window.removeEventListener('resize', syncHeaderOffset);
      if (backdrop) {
        backdrop.hidden = true;
        backdrop.classList.remove('search-overlay-backdrop--closing');
      }
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', syncViewportHeight);
      }
      dialog.style.removeProperty('--search-viewport-height');
      dialog.style.removeProperty('--search-header-offset');
      resetOverlay();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
